import { render } from "./InteractionItem.vue?vue&type=template&id=78dbbf1b&ts=true"
import script from "./InteractionItem.vue?vue&type=script&lang=ts"
export * from "./InteractionItem.vue?vue&type=script&lang=ts"

import "./InteractionItem.vue?vue&type=style&index=0&id=78dbbf1b&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__